<template>
  <div class="unit-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <h3 class="font-size">{{ floorName }}布局 <span style="font-weight: normal;font-size: 14px;color: #999;">（点击单元/房间可修改信息）</span>
        </h3>
        <el-button type="primary" v-if="unit.length === 0" @click="unitDialog = true">楼栋设置</el-button>
      </div>

      <div class="padding-tb">
        <div class="w-all margin-bottom-sm" v-for="item in unit" :key="item.element_id" >
          <div class="unit-scroll">
            <div  class="unit-box"
                 :style="{width:(item.chuan_index*150+1) + 'px'} ">
              <div class="flex align-center">
                <div v-for="(chuan,cindex) in item.chuan_index" :key="cindex" class="unit-item active"
                     style="width: 150px">
                  {{ chuan }}串
                </div>
              </div>
              <div class="flex align-center flex-wrap">
                <div v-for="room in item.room" :key="room.id" class="unit-item" style="width: 150px"
                     @click="editItem(room.room_name,room.id,room.status)">
                  {{ room.status === 1 ? (floorName + '-' + item.element_name + '-' + room.room_name) : '--'  }}
                </div>
              </div>
              <div class="unit-name" @click="editUnit(item.element_name,item.element_id)">{{ item.element_name }}</div>
            </div>
          </div>
        </div>


      </div>

      <div class="no-data" v-if="noData">
        <img src="../../assets/img/no-data.png" alt="">
        <p>您还未创建楼栋信息，赶快创建吧！</p>
      </div>
    </div>
    <unitDialog
        :unitDialog="unitDialog"
        @cancelDialog="cancelDialog"
    />
    <roomDialog
        :roomDialog="roomDialog"
        :editName="editName"
        :editId="editId"
        :editStatus="editStatus"
        @cancelDialog="cancelDialog"
    />
    <unitNameDialog
        :unitNameDialog="unitNameDialog"
        :editName="editName"
        :editId="editId"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {menHuList} from "@/api/community";
import unitDialog from "@/views/pages/dialog/unitDialog";
import roomDialog from "@/views/pages/dialog/roomDialog";
import unitNameDialog from "@/views/pages/dialog/unitNameDialog";

export default {
  name: "unit-management",
  data() {
    return {
      floorName: '',
      projectId: '',
      communityId: '',
      floorId: '',
      unit: [],
      unitDialog: false,
      roomDialog: false,
      unitNameDialog: false,
      noData: false,
      editName: '',
      editId: 0,
      editStatus: 1,
    }
  },
  created() {
    this.$emit("setIndex", '/home/community', "系统管理 / 小区管理 / 楼宇设置", true);
    this.projectId = this.$route.params.pid
    this.communityId = this.$route.params.cid
    this.floorId = this.$route.params.fid
    this.floorName = this.$route.query.name
    this.menHuList()
  },
  components: {
    unitDialog,
    roomDialog,
    unitNameDialog
  },
  methods: {
    //  修改单元信息
    editUnit(name,id){
      this.unitNameDialog = true
      this.editName = name
      this.editId = id
    },
    //  修改房间信息
    editItem(name, id, status) {
      this.roomDialog = true
      this.editName = name
      this.editId = id
      this.editStatus = status
    },
    //  楼栋设置后回调
    cancelDialog() {
      this.unitDialog = false
      this.roomDialog = false
      this.unitNameDialog = false
      this.editName = ''
      this.editId = 0
      this.editStatus = 1
      this.menHuList()
    },
    //  获取楼的单元及布局
    async menHuList() {
      let _list = await menHuList(this.floorId, this.communityId, this.projectId)
      if (_list.status !== 200) return this.noData = true
      this.floorName = _list.data.building_name
      this.unit = _list.data.list
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.unit-warpper {
  .unit-scroll {
    width: 100%;
    overflow: auto;

    .unit-box {
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      box-sizing: border-box;

      .unit-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 50px;
        box-sizing: border-box;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &.active {
          background: #eee;
          cursor: unset;
        }
      }

      .unit-name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        color: #d00000;
        border: 1px solid #eeee;
        border-top: 0;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }


  .no-data {
    img {
      display: block;
      margin: 30px auto;
    }

    p {
      text-align: center;
    }
  }
}
</style>